export const mutations = {
  count (state, count) {
    state.count = count
  },
  sideNav (state, nav) {
    state.sideNav = nav
  },
  addRole (state, roleInfo) {
    state.roleInfo = roleInfo
  },
  setPermissionTree (state, permissionTree) {
    state.permissionTree = permissionTree
  },
  // 刷新页面时从localstorage中取值，并重置activeTabsList
  resetActiveTabsList (state, activeTabsList) {
    state.activeTabsList = activeTabsList
  },
  // 路由跳转时将路由添加到激活页面列表中，需要判断是否存在
  setActiveTabs (state, activeTabs) {
    let flag = true
    if (state.activeTabsList.length > 0) {
      state.activeTabsList.map((item) => {
        if (item.route_url === activeTabs.route_url) flag = false
      })
    }
    if (flag) {
      state.activeTabsList.push(activeTabs)
    }
    window.localStorage.setItem('activeTabsList', JSON.stringify(state.activeTabsList))
  },
  // 将需要删除的页面从列表中移除
  removeActiveTabs (state, tabIndex) {
    if (tabIndex >= 0) state.activeTabsList.splice(tabIndex, 1)
    window.localStorage.setItem(
      'activeTabsList',
      JSON.stringify(state.activeTabsList)
    )
  },
  // 当前页面所在路由
  setActiveTab (state, activeTab) {
    state.activeTab = activeTab.substr(1)
    // console.log(activeTab.substr(1), 'vuex')
    window.localStorage.setItem('activeTab', state.activeTab)
  },
  setMenuTree (state, menuTree) {
    state.menuTree = menuTree
  },
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
  },
  setOrgainzationTree (state, orgainzationTree) {
    state.orgainzationTree = orgainzationTree
  },
  setEntityTree (state, entityTree) {
    state.entityTree = entityTree
  },
  // 设置页面模块维护树
  setPageComTree (state, pageComTree) {
    state.pageComTree = pageComTree
    window.localStorage.setItem('platformPageComTree', JSON.stringify(pageComTree))
  },
  setPageIndicatorTree (state, data) {
    state.pageIndicatorTree = data
    window.localStorage.setItem('platformPageIndicatorTree', JSON.stringify(data))
  },
  // 设置页面实例树
  setPageInstanceTree (state, pageInstanceTree) {
    state.pageInstanceTree = pageInstanceTree
    window.localStorage.setItem('pageInstanceTree', JSON.stringify(pageInstanceTree))
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js